import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { Checkbox, Grid } from '@mui/material';
import { Button, Typography } from '@totalsoft/rocket-ui';
import { BulkActionsContainer, BulkActionsTriangle } from 'features/document/edit/documents/components/DocumentsStyles';

function PartnerFileBulkActions({ allPartnersSelected, anyPartnerSelected, onSelectAllPartners, onAddBulkFile, saving }) {
  const { t } = useTranslation();

  return (
    <>
      <BulkActionsContainer container alignItems='center' px={3} py={0.75} minHeight={7.5}>
        <Grid item xs='auto' mr={3.5}>
          <Checkbox
            checked={allPartnersSelected}
            indeterminate={!allPartnersSelected && anyPartnerSelected}
            onChange={onSelectAllPartners}
            disabled={saving}
          />
        </Grid>
        <Grid item container xs='auto' mr={3.5} gap={2} alignItems='center'>
          <Typography>{t('BulkPartners.BulkSelection')}</Typography>
          <Button
            variant='outlined'
            color='primary'
            tooltip={t('BulkPartners.AddBulkFile')}
            onClick={onAddBulkFile}
            disabled={!anyPartnerSelected || saving}
          >
            {t('BulkPartners.AddBulkFile')}
          </Button>
        </Grid>
      </BulkActionsContainer>
      <BulkActionsTriangle sx={{ ml: 4.5, mb: 0 }} />
    </>
  );
}

PartnerFileBulkActions.propTypes = {
  allPartnersSelected: PropTypes.bool.isRequired,
  anyPartnerSelected: PropTypes.bool.isRequired,
  onSelectAllPartners: PropTypes.func.isRequired,
  onAddBulkFile: PropTypes.func.isRequired,
  saving: PropTypes.bool.isRequired
};

export default PartnerFileBulkActions;
